import { Button } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

const propTypes = {
  /**
   * If true, disable both buttons
   */
  isLoading: PropTypes.bool,
  /**
   * Color variant of the primary button
   * If variant is 'engage' primary button will be colored purple
   */
  modalVariant: PropTypes.oneOf(['primary', 'engage']),
  /**
   * Left button props (label, onClick, variant, etc)
   */
  leftButton: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Right button props (label, onClick, variant, etc), or a rendered action group.
   */
  rightButton: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
}

function Footer(props) {
  const { modalVariant = 'primary', isLoading = false, leftButton = {}, rightButton = {} } = props ?? {}

  return (
    <Modal.Footer className="d-flex justify-content-between align-items-center">
      <div>{leftButton && <FooterButton {...leftButton} isLoading={isLoading} modalVariant={modalVariant} />}</div>
      <div>
        {React.isValidElement(rightButton)
          ? rightButton
          : rightButton && <FooterButton {...rightButton} isLoading={isLoading} modalVariant={modalVariant} />}
      </div>
    </Modal.Footer>
  )
}

function FooterButton(props) {
  const { label, isLoading, className, variant, modalVariant, disabled = false, disabledTooltip, id, ...rest } = props // eslint-disable-line react/prop-types
  const intl = useIntl()

  if (!label) {
    return null
  }

  const engageBtnClass = modalVariant === 'engage' && variant === 'primary' ? 'btn-engage' : ''
  const isDisabled = isLoading || disabled
  const tooltipId = id ? `${id}-disabled-tooltip` : 'modal-footer-button-disabled-tooltip'

  const button = (
    <Button id={id} disabled={isDisabled} variant={variant} className={clsx(className, engageBtnClass)} {...rest}>
      <FormattedMessage id={label} />
    </Button>
  )

  if (!isDisabled || !disabledTooltip) {
    return button
  }

  return (
    <OverlayTrigger
      placement="top"
      trigger="hover"
      overlay={
        <Tooltip id={tooltipId} className="modal-tooltip">
          {intl.formatMessage({ id: disabledTooltip })}
        </Tooltip>
      }
    >
      <span className="d-inline-block">{button}</span>
    </OverlayTrigger>
  )
}

Footer.propTypes = propTypes

export default Footer
